import React, { useState } from "react";
import { Link } from "react-router-dom";
import { projects, site } from "../generated/content";
import { useLanguage } from "../context/LanguageContext";
import { projectMeta } from "../lib/projectMeta";
import Header from "./Header";
import HeroSlider from "./HeroSlider";
import Services from "./Services";
import AboutUs from "./AboutUs";
import Footer from "./Footer";
import LoadingScreen from "./LoadingScreen";
import "../style/HomeScreen.css";

export default function HomeScreen() {
  const { lang, t } = useLanguage();
  const [heroReady, setHeroReady] = useState(false);

  const sliderProjects = projects.filter((project) => project.showInSlider);
  const featured = sliderProjects.length > 0 ? sliderProjects : projects;

  return (
    <>
      {/* Content ships inside the bundle, so the only real wait is the first
          photograph. The splash covers exactly that and nothing longer. */}
      {!heroReady && <LoadingScreen title={site.companyName} />}

      <Header overHero />
      <HeroSlider projects={featured} onFirstImageLoad={() => setHeroReady(true)} />

      <Services />
      <AboutUs />

      <section className="work" aria-labelledby="work-title">
        <h2 id="work-title" className="section-title">
          {lang === "en" ? "Projects" : "Projeler"}
        </h2>

        <div className="work__grid">
          {projects.map((project) => {
            const meta = projectMeta(project, lang);
            return (
              <Link key={project.slug} className="card" to={`/projects/${project.slug}`}>
                {/* sizes mirrors the grid: one column on a phone, about a
                    third of the width on a desktop. */}
                <figure className="card__frame">
                  <img
                    src={project.cover.src}
                    srcSet={project.cover.srcSet}
                    sizes="(max-width: 600px) 100vw, (max-width: 1100px) 50vw, 33vw"
                    alt={t(project.title)}
                    loading="lazy"
                  />
                </figure>
                <h3>{t(project.title)}</h3>
                {meta && <p className="meta-line">{meta}</p>}
              </Link>
            );
          })}
        </div>
      </section>

      <Footer />
    </>
  );
}
